// 2023/01/11 Leading Win 教育機能対応 DXWEBEFN00100_新規入場・送り出し教育 start
import { FC, useState, useEffect, useRef, useCallback } from 'react';
import { Button, message, Radio, Spin } from 'antd';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useAppDispatch } from 'hooks';
import { TextAreaField, SelectField, InputField, CheckboxField } from 'components';
import { MedicalList } from 'types';
import { dayjs } from 'libs';
import { FormikProvider, useFormik } from 'formik';
import { Form } from 'formik-antd';
import { userData } from 'pages/Login/selectors';
import type { RadioChangeEvent } from 'antd';
import ButtonSubmit from 'components/Forms/ButtonSubmit';
import { SupportSite } from 'constant';
// 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ start
import Kakunin from './Kakunin';
// 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ end
import { NewentrantSendoffStyled } from './styles';

import {
  getNewentrantEducation,
  getSendoffEducation,
  getEducationStatus,
  getUpperCooperatorList,
  educationNewentrantRegister,
  educationSendoffRegister,
} from './thunk';
import { actions } from './slice';
import { newentrantSendoffSelector } from './selectors';

const NewentrantSendoff: FC = () => {
  const dispatch = useAppDispatch();
  const {
    newentrantEducation,
    sendoffEducation,
    loading,
    newcomer_education_status,
    sendoff_education_status,
    upperCooperatorList,
    educationSendStatus,
    workerDatas,
    num,
  } = useSelector(newentrantSendoffSelector);
  const [showNewFlg, setShowNewFlg] = useState<boolean>(false);
  const [showSendFlg, setShowSendFlg] = useState<boolean>(false);
  const [newOpenFlg, setNewOpenFlg] = useState<boolean>(true);
  const [sendOpenFlg, setSendOpenFlg] = useState<boolean>(true);
  const [inDisabled, setInDisabled] = useState<boolean>(true);

  const [isKakunin, setisKakunin] = useState<boolean>(false);

  const [disabledNew, setDisabledNew] = useState<boolean>(false);
  const [disabledSend, setDisabledSend] = useState<boolean>(false);
  const [initLoading, setInitLoading] = useState<boolean>(false);
  const [scrollFlg, setScrollFlg] = useState<boolean>(false);
  // 持病フラグ (0：無、1：有)
  const [chronic_disease_flg, setChronicDiseaseFlg] = useState<string | number>('');
  // 在留区分 (0：未確認、1：確認済)
  const [visa_status_kbn, setVisaStatusKbn] = useState<string | number>('');
  // 既往歴有無 (0：ない、1：ある)
  const [medical_history_flg, setMedicalHistoryFlg] = useState('');
  const [disabledHistory, setDisabledHistory] = useState(true);
  // 作業制限有無 (0：できる、1：できない)
  const [work_limit_flg, setWorkLimitFlg] = useState('');
  const [disabledLimit, setDisabledLimit] = useState(true);
  const [disabledElse, setDisabledElse] = useState(true);

  const history = useHistory();

  // パラメータ
  const location = useLocation();
  const params: any = location.state;
  const worker_datas = params.worker_datas;
  // パラメータの教育情報リストをSTATEに設定する。
  dispatch(actions.setWorkerDatas(worker_datas));
  // ユーザID
  const { user_id } = useSelector(userData);
  // state.教育実施状況確認情報リストから処理対象となる情報を1件取得する。
  let worker_data = workerDatas[num];

  const chronic_disease_flg_scroll = useRef<null | HTMLDivElement>(null);
  const visa_status_kbn_scroll = useRef<null | HTMLDivElement>(null);
  const cooperator_scroll = useRef<null | HTMLDivElement>(null);
  const newentrant_user_name_scroll = useRef<null | HTMLDivElement>(null);
  const compliance_check_scroll = useRef<null | HTMLDivElement>(null);
  const medical_history_flg_scroll = useRef<null | HTMLDivElement>(null);
  const emergency_report_check_scroll = useRef<null | HTMLDivElement>(null);
  const sendoff_user_name_scroll = useRef<null | HTMLDivElement>(null);

  const observance_scroll = useRef<null | HTMLDivElement>(null);
  const medical_history_list_scroll = useRef<null | HTMLDivElement>(null);
  const medical_history_else_scroll = useRef<null | HTMLDivElement>(null);
  const work_limit_flg_scroll = useRef<null | HTMLDivElement>(null);
  const work_limit_reason_scroll = useRef<null | HTMLDivElement>(null);
  // 遵守事項スクロール
  const textarea = document.getElementById('textArea');

  // 画面の初期処理
  useEffect(() => {
    (async () => {
      setInitLoading(true);
      initValues();
      worker_data = worker_datas[num];
      // 「教育状況取得API」を呼出し、教育状況を取得する。
      const education = await dispatch(
        getEducationStatus({
          user_id: worker_data?.users_id || 0,
          cooperator_code: worker_data?.cooperator_code || '',
          site_id: worker_data?.site_id || 0,
        })
      );
      let educationStatus: any;
      if (education && getEducationStatus?.fulfilled?.match(education)) {
        educationStatus = education.payload;
      }
      // state.新規入場者教育ステータス='2'(承認済) and state送り出し教育ステータス='2'(承認済)の場合
      if (
        educationStatus.newcomer_education_status === 2 &&
        educationStatus.sendoff_education_status === 2
      ) {
        message.info(
          '新規入場者教育、送り出し教育が既に承認済みの為、実施することが出来ません。',
          4
        );
        dispatch(actions.setNum({ num: 0 }));
        dispatch(actions.setSendFlg({ send_flg: 0 }));
        history.push(SupportSite.EducationStatus);
      }
      // state.新規入場者教育ステータス='1'(実施済)の場合
      if (educationStatus.newcomer_education_status === 1) {
        // 更新無チェックボックスを表示する。
        formik.values.newentrant_check = true;
        // '1'を登録する ※0：チェックなし、1：チェックあり
        dispatch(actions.setNewentrantUpdateNotCheckBox({ updateNotCheckBox: 1 }));
      }
      // state.新規入場者教育ステータス='0'(未実施) or '1'(実施済)の場合
      if (
        educationStatus.newcomer_education_status === 0 ||
        educationStatus.newcomer_education_status === 1
      ) {
        // 新規入場者教育の表示領域を表示する。
        setShowNewFlg(true);
        // 活性・非活性条件(初期表示)
        if (educationStatus.newcomer_education_status === 0) {
          setDisabledNew(false);
        }
        if (educationStatus.newcomer_education_status === 1) {
          setDisabledNew(true);
        }
        // 「新規入場者教育取得API」を呼出し、画面へ表示する。
        const newentrant = await dispatch(
          getNewentrantEducation({
            user_id: worker_data?.users_id || 0,
            cooperator_code: worker_data?.cooperator_code || '',
            site_id: worker_data?.site_id || 0,
          })
        );
        let newentrantEntity: any;
        if (newentrant && getNewentrantEducation?.fulfilled?.match(newentrant)) {
          newentrantEntity = newentrant.payload;
        }
        // 「上位協力業者情報リスト取得API」を呼出し、プルダウンにセットする。
        await dispatch(
          getUpperCooperatorList({
            user_id: worker_data?.users_id || 0,
            cooperator_code: worker_data?.cooperator_code || '',
            site_id: worker_data?.site_id || 0,
          })
        );

        // 在留カードのデフォルト値
        if (newentrantEntity?.nationality_flg === 0) {
          // 外国籍フラグ = 0 (日本籍)の場合：3 (対象外)
          setVisaStatusKbn(3);
        } else {
          // 外国籍フラグ = 1 (外国籍)の場合：0 (未確認)
          setVisaStatusKbn(0);
        }
      } else {
        // 新規入場者教育の表示領域を表示しない。
        setShowNewFlg(false);
        setNewOpenFlg(false);
      }

      // state.送り出し教育ステータス='1'(実施済)の場合
      if (educationStatus.sendoff_education_status === 1) {
        // 更新無チェックボックスを表示する。
        formik.values.sendoff_check = true;
        // '1'を登録する ※0：チェックなし、1：チェックあり
        dispatch(actions.setSendoffUpdateNotCheckBox({ updateNotCheckBox: 1 }));
      }
      // state.送り出し教育ステータス='0'(未実施) or '1'(実施済)の場合
      if (
        educationStatus.sendoff_education_status === 0 ||
        educationStatus.sendoff_education_status === 1
      ) {
        // 送り出し教育の表示領域を表示する。
        setShowSendFlg(true);
        // 活性・非活性条件(初期表示)
        if (educationStatus.sendoff_education_status === 0) {
          setDisabledSend(false);
        }
        if (educationStatus.sendoff_education_status === 1) {
          setDisabledSend(true);
        }
        // 「送り出し教育取得API」を呼出し、画面へ表示する。
        await dispatch(
          getSendoffEducation({
            user_id: worker_data?.users_id || 0,
            cooperator_code: worker_data?.cooperator_code || '',
            site_id: worker_data?.site_id || 0,
          })
        );
      } else {
        // 送り出し教育の表示領域を表示しない。
        setShowSendFlg(false);
        setSendOpenFlg(false);
      }
      setInitLoading(false);
    })();
  }, [num]);

  const initValues = () => {
    // 持病フラグ (0：無、1：有)
    setChronicDiseaseFlg('');
    // 在留区分 (0：未確認、1：確認済)
    setVisaStatusKbn('');
    // 既往歴有無 (0：ない、1：ある)
    setMedicalHistoryFlg('');
    setDisabledHistory(true);
    // 作業制限有無 (0：できる、1：できない)
    setWorkLimitFlg('');
    setDisabledLimit(true);
    setDisabledElse(true);
    formik.resetForm();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (textarea) {
      textarea.scrollTop = 0;
    }
  };
  // 持病フラグ (0：無、1：有)
  const onChangeChronicDiseaseFlg = (e: RadioChangeEvent) => {
    setChronicDiseaseFlg(e.target.value);
  };
  // 在留区分 (0：未確認、1：確認済)
  const onChangeVisaStatusKbn = (e: RadioChangeEvent) => {
    setVisaStatusKbn(e.target.value);
  };
  // 既往歴有無 (0：ない、1：ある)
  const onChangeMedicalHistoryFlg = (e: RadioChangeEvent) => {
    //「既往歴有無」の「ある」を選択
    // 以下の項目は、非活性から活性を変更する。
    // 既往歴チェック
    // 作業制限有無
    if (e.target.value === '1') {
      setDisabledHistory(false);
    } else {
      setDisabledHistory(true);
      setDisabledLimit(true);
      setDisabledElse(true);
    }
    setMedicalHistoryFlg(e.target.value);
  };
  // 作業制限有無 (0：できる、1：できない)
  const onChangeWorkLimitFlg = (e: RadioChangeEvent) => {
    //「作業制限有無」の「できない」を選択
    // 以下の項目は、非活性から活性を変更する。
    // 作業制限理由
    if (e.target.value === '1') {
      setDisabledLimit(false);
    } else {
      setDisabledLimit(true);
    }
    setWorkLimitFlg(e.target.value);
  };

  // 新規入場者教育の「実施教育者 会社名」プルダウン押下
  const setCooperator = (item: any) => {
    const educator = upperCooperatorList?.educator_cooperator_list?.find(
      (cooperator) => cooperator.cooperator_code == item
    );
    if (item === '大東建託') {
      dispatch(
        actions.setCooperator({
          educator_flg: 1, // (大東建託)
          cooperator_code: '',
          cooperator_name: '大東建託',
        })
      );
    } else {
      dispatch(
        actions.setCooperator({
          educator_flg: 0, // (それ以外)
          cooperator_code: educator?.cooperator_code,
          cooperator_name: educator?.cooperator_name,
        })
      );
    }
  };

  // 遵守事項スクロール
  textarea?.addEventListener('scroll', function () {
    const isScrolledToBottom =
      textarea?.scrollHeight - textarea?.scrollTop === textarea?.clientHeight;
    if (isScrolledToBottom) {
      setScrollFlg(true);
    } else {
      setScrollFlg(false);
    }
  });

  const formik = useFormik({
    initialValues,
    async onSubmit(values) {
      // 必須項目が入力されているかどうか
      // 新規入場者教育
      if (
        newcomer_education_status === 0 ||
        (newcomer_education_status === 1 && !values.newentrant_check)
      ) {
        // 新規入場者教育内容.持病
        if (chronic_disease_flg === '') {
          message.info({
            content: `必須項目が入力されていません。\n　　入力内容を再度確認してください。`,
            style: {
              whiteSpace: 'pre-wrap',
            },
          });
          chronic_disease_flg_scroll.current?.scrollIntoView({
            behavior: 'smooth',
          });
          return;
        }
        // 新規入場者教育内容.在留カード
        if (visa_status_kbn === '') {
          message.info({
            content: `必須項目が入力されていません。\n　　入力内容を再度確認してください。`,
            style: {
              whiteSpace: 'pre-wrap',
            },
          });
          visa_status_kbn_scroll.current?.scrollIntoView({
            behavior: 'smooth',
          });
          return;
        }
        // 新規入場者教育内容.教育実施者.会社名
        if (formik.values.cooperator === '') {
          message.info({
            content: `必須項目が入力されていません。\n　　入力内容を再度確認してください。`,
            style: {
              whiteSpace: 'pre-wrap',
            },
          });
          cooperator_scroll.current?.scrollIntoView({
            behavior: 'smooth',
          });
          return;
        }
        // 新規入場者教育内容.教育実施者.氏名
        if (formik.values.newentrant_user_name === '') {
          message.info({
            content: `必須項目が入力されていません。\n　　入力内容を再度確認してください。`,
            style: {
              whiteSpace: 'pre-wrap',
            },
          });
          newentrant_user_name_scroll.current?.scrollIntoView({
            behavior: 'smooth',
          });
          return;
        }
      }

      //　送り出し教育
      if (
        sendoff_education_status === 0 ||
        (sendoff_education_status === 1 && !values.sendoff_check)
      ) {
        //　送り出し教育内容.遵守事項リスト.遵守事項チェック
        let compliance_check_flg = true;
        sendoffEducation?.compliance_list?.forEach((item, i) => {
          const compliance_check = document.getElementsByName(
            'compliance_check' + i
          )[0] as HTMLInputElement;
          if (!compliance_check.checked) {
            compliance_check_flg = false;
          }
          console.log(item);
        });
        if (!compliance_check_flg) {
          message.info({
            content: `必須項目が入力されていません。\n　　入力内容を再度確認してください。`,
            style: {
              whiteSpace: 'pre-wrap',
            },
          });
          compliance_check_scroll.current?.scrollIntoView({
            behavior: 'smooth',
          });
          return;
        }
        // 送り出し教育内容.既往歴有無-質問.既往歴有無
        if (medical_history_flg === '') {
          message.info({
            content: `必須項目が入力されていません。\n　　入力内容を再度確認してください。`,
            style: {
              whiteSpace: 'pre-wrap',
            },
          });
          medical_history_flg_scroll.current?.scrollIntoView({
            behavior: 'smooth',
          });
          return;
        }
        // 送り出し教育内容.緊急時報告固定文.緊急時報告チェック
        if (!formik.values.emergency_report_check) {
          message.info({
            content: `必須項目が入力されていません。\n　　入力内容を再度確認してください。`,
            style: {
              whiteSpace: 'pre-wrap',
            },
          });
          emergency_report_check_scroll.current?.scrollIntoView({
            behavior: 'smooth',
          });
          return;
        }
        // 送り出し教育内容.教育実施者.氏名
        if (formik.values.sendoff_user_name === '') {
          message.info({
            content: `必須項目が入力されていません。\n　　入力内容を再度確認してください。`,
            style: {
              whiteSpace: 'pre-wrap',
            },
          });
          sendoff_user_name_scroll.current?.scrollIntoView({
            behavior: 'smooth',
          });
          return;
        }
      }

      // 新規入場の遵守事項のスクロールバーが最後尾に到達していません
      if (
        (newcomer_education_status === 0 ||
          (newcomer_education_status === 1 && !values.newentrant_check)) &&
        !scrollFlg
      ) {
        message.info('新規入場者教育の遵守事項を確認してください。');
        observance_scroll.current?.scrollIntoView({
          behavior: 'smooth',
        });
        return;
      }

      // [既往歴有無='1'(あり)の場合]
      if (
        (sendoff_education_status === 0 ||
          (sendoff_education_status === 1 && !values.sendoff_check)) &&
        medical_history_flg === '1'
      ) {
        // [既往歴有無='1'(あり)、かつ、全ての既往歴チェック='0'(チェック無し)の場合]
        let medical_history = true;
        sendoffEducation?.medical_history_list?.forEach((i) => {
          const medical_history_check = document.getElementsByName(
            'medical_history_code' + i.medical_history_code
          )[0] as HTMLInputElement;
          if (medical_history_check?.checked) {
            medical_history = false;
          }
        });

        if (medical_history) {
          message.info({
            content: `必須項目が入力されていません。\n　　　下記項目を再度確認してください。\n・既往歴　　　　　　　　　　`,
            style: {
              whiteSpace: 'pre-wrap',
            },
          });
          medical_history_list_scroll.current?.scrollIntoView({
            behavior: 'smooth',
          });
          return;
        }

        // [既往歴有無='1'(あり)、かつ、その他の既往歴チェック='1'(チェック有)、かつ、既往歴その他がブランクの場合]
        const else_check = document.getElementsByName(
          'medical_history_code' + 99
        )[0] as HTMLInputElement;

        // その他の既往歴チェック='1'(チェック有)、かつ、既往歴その他がブランク
        if (else_check?.checked && values.medical_history_else === '') {
          message.info({
            content: `必須項目が入力されていません。\n　　　下記項目を再度確認してください。\n・既往歴その他入力欄　　　　`,
            style: {
              whiteSpace: 'pre-wrap',
            },
          });
          medical_history_else_scroll.current?.scrollIntoView({
            behavior: 'smooth',
          });
          return;
        }
        // [既往歴有無='1'(あり)、かつ、作業制限有無がブランクの場合]
        if (work_limit_flg === '') {
          message.info({
            content: `必須項目が入力されていません。\n　　　下記項目を再度確認してください。\n・既往歴作業制限　　　　　　`,
            style: {
              whiteSpace: 'pre-wrap',
            },
          });
          work_limit_flg_scroll.current?.scrollIntoView({
            behavior: 'smooth',
          });
          return;
        }
        // [既往歴有無='1'(あり)、かつ、作業制限有無='1'(できない)、かつ、作業制限理由がブランクの場合]
        if (work_limit_flg === '1' && values.work_limit_reason === '') {
          message.info({
            content: `必須項目が入力されていません。\n　　　下記項目を再度確認してください。\n・既往歴作業制限入力欄　　　`,
            style: {
              whiteSpace: 'pre-wrap',
            },
          });
          work_limit_reason_scroll.current?.scrollIntoView({
            behavior: 'smooth',
          });
          return;
        }
      }

      // 教育実施状況確認情報リストが複数件の場合
      if (worker_datas.length > 1) {
        setisKakunin(true);
      } else {
        onOk();
      }
    },
  });

  const onCancel = () => {
    setisKakunin(false);
    last();
  };

  const onOk = async () => {
    setisKakunin(false);
    // 「教育状況取得API」を呼出し、実施状況を確認する。
    const education = await dispatch(
      getEducationStatus({
        user_id: worker_data?.users_id || 0,
        cooperator_code: worker_data?.cooperator_code || '',
        site_id: worker_data?.site_id || 0,
      })
    );
    let educationStatus: any;
    if (education && getEducationStatus?.fulfilled?.match(education)) {
      educationStatus = education.payload;
    }
    // state.新規入場者教育ステータス='2'(承認済) and state.送り出し教育ステータス='2'(承認済)の場合
    if (
      educationStatus.newcomer_education_status === 2 &&
      educationStatus.sendoff_education_status === 2
    ) {
      // 実施不可のメッセージを表示し、「現場情報」画面へ遷移する。
      message.info('新規入場者教育、送り出し教育が既に承認済みの為、実施することが出来ません。');
      dispatch(actions.setNum({ num: 0 }));
      dispatch(actions.setSendFlg({ send_flg: 0 }));
      history.push(SupportSite.EducationStatus);
      return;
    } else {
      // state.新規入場者教育ステータス='0'(未実施) or '1'(実施済)
      // かつ、state.新規入場者教育.更新無チェックボックス='0'(チェック無)の場合
      if (
        (educationStatus.newcomer_education_status === 0 ||
          educationStatus.newcomer_education_status === 1) &&
        newentrantEducation.updateNotCheckBox === 0
      ) {
        await dispatch(
          educationNewentrantRegister({
            user_id: user_id || 0,
            user_j_id: worker_data?.users_id || 0,
            cooperator_code: worker_data?.cooperator_code || '',
            site_id: worker_data?.site_id || 0,
            chronic_disease_flg: Number(chronic_disease_flg),
            visa_status_kbn: Number(visa_status_kbn),
            educator: {
              educator_flg: newentrantEducation?.educator?.educator_flg,
              cooperator_code: newentrantEducation?.educator?.cooperator_code,
              user_name: formik.values.newentrant_user_name,
            },
            date: dayjs().toDate(),
          })
        );
      }

      // state.送り出し教育ステータス='0'(未実施) or state.送り出し教育ステータス='1'(実施済)、
      // かつ、state.送り出し教育.更新無チェックボックス='0'(チェック無)の場合
      if (
        (educationStatus.sendoff_education_status === 0 ||
          educationStatus.sendoff_education_status === 1) &&
        sendoffEducation.updateNotCheckBox === 0
      ) {
        // 既往歴list
        let medical_history_list: MedicalList[] = [];
        // 既往歴その他
        let medical_history_else = '';
        // 作業制限有無
        let work_limit_flg_value = '';
        // 作業制限理由
        let work_limit_reason = '';
        // 既往歴有無='1'(あり)
        if (medical_history_flg === '1') {
          //既往歴
          sendoffEducation?.medical_history_list?.forEach((i) => {
            const medical_history_check = document.getElementsByName(
              'medical_history_code' + i.medical_history_code
            )[0] as HTMLInputElement;
            if (medical_history_check?.checked) {
              medical_history_list.push({ medical_history_code: `${i.medical_history_code}` });
            }
          });
          // 既往歴その他
          const else_check = document.getElementsByName(
            'medical_history_code' + 99
          )[0] as HTMLInputElement;
          if (else_check?.checked) {
            medical_history_else = formik.values.medical_history_else;
          }
          // 作業制限有無
          work_limit_flg_value = work_limit_flg;
          // 作業制限理由
          if (work_limit_flg_value) {
            work_limit_reason = formik.values.work_limit_reason;
          }
        }

        //「送り出し教育登録API」を呼出し、送り出し教育の情報を基幹システムへ連携する。
        await dispatch(
          educationSendoffRegister({
            user_id: user_id || 0,
            user_j_id: worker_data?.users_id || 0,
            cooperator_code: worker_data?.cooperator_code || '',
            site_id: worker_data?.site_id || 0,
            medical_history_flg: medical_history_flg,
            medical_history_list: medical_history_list,
            medical_history_else: medical_history_else,
            work_limit_flg: work_limit_flg_value,
            work_limit_reason: work_limit_reason,
            educator: { user_name: formik.values.sendoff_user_name },
            date: dayjs().toDate(),
          })
        );
      }

      // 送信完了フラグに1（送信済）を設定する。
      dispatch(actions.setSendFlg({ send_flg: 1 }));
      last();
    }
  };

  const last = useCallback(() => {
    // リストに後続のデータが存在しない場合
    if (num === worker_datas.length - 1) {
      // 「教育実施状況確認」画面へ送信完了フラグを連携し遷移する。
      dispatch(actions.setNum({ num: 0 }));
      dispatch(actions.setSendFlg({ send_flg: 0 }));
      history.push({
        pathname: SupportSite.EducationStatus,
        state: { send_image_flg: educationSendStatus.send_flg },
      });
    } else {
      // 次のパラメータ.教育実施状況確認情報リストの初期表示処理を行う。
      dispatch(actions.setNum({ num: num + 1 }));
    }
  }, [educationSendStatus, num]);

  // 入力項目入力済(遵守事項スクロール済)
  useEffect(() => {
    let compliance_check_flg = true;
    let new_disabled_flg = true;
    let send_disabled_flg = true;
    // 新規入場者教育内容.持病
    // 新規入場者教育内容.在留カード
    // 新規入場者教育内容.教育実施者.会社名
    // 新規入場者教育内容.教育実施者.氏名
    if (newcomer_education_status !== 2) {
      if (
        scrollFlg &&
        chronic_disease_flg !== '' &&
        visa_status_kbn !== '' &&
        formik.values.cooperator !== '' &&
        formik.values.newentrant_user_name !== ''
      ) {
        new_disabled_flg = false;
      } else {
        new_disabled_flg = true;
      }
    }

    // 送り出し教育内容.遵守事項リスト.遵守事項チェック
    // 送り出し教育内容.既往歴有無-質問.既往歴有無
    // 送り出し教育内容.緊急時報告固定文.緊急時報告チェック
    // 送り出し教育内容.教育実施者.氏名
    if (sendoff_education_status !== 2) {
      sendoffEducation?.compliance_list?.forEach((item, i) => {
        const compliance_check = document.getElementsByName(
          'compliance_check' + i
        )[0] as HTMLInputElement;
        if (compliance_check?.checked) {
          compliance_check_flg = false;
        } else {
          compliance_check_flg = true;
        }
        console.log(item);
      });
      if (
        !compliance_check_flg &&
        medical_history_flg !== '' &&
        formik.values.emergency_report_check &&
        formik.values.sendoff_user_name !== ''
      ) {
        send_disabled_flg = false;
      } else {
        send_disabled_flg = true;
      }
    }

    // 「確定」活性・非活性
    if (newcomer_education_status === 0 && sendoff_education_status === 0) {
      if (!new_disabled_flg && !send_disabled_flg) {
        setInDisabled(false);
      } else {
        setInDisabled(true);
      }
    }
    if (newcomer_education_status === 0 && sendoff_education_status === 1) {
      if (
        !new_disabled_flg &&
        ((!send_disabled_flg && !formik.values.sendoff_check) || formik.values.sendoff_check)
      ) {
        setInDisabled(false);
      } else {
        setInDisabled(true);
      }
    }
    if (newcomer_education_status === 0 && sendoff_education_status === 2) {
      if (!new_disabled_flg) {
        setInDisabled(false);
      } else {
        setInDisabled(true);
      }
    }
    if (newcomer_education_status === 1 && sendoff_education_status === 0) {
      if (
        ((!new_disabled_flg && !formik.values.newentrant_check) ||
          formik.values.newentrant_check) &&
        !send_disabled_flg
      ) {
        setInDisabled(false);
      } else {
        setInDisabled(true);
      }
    }
    if (newcomer_education_status === 1 && sendoff_education_status === 1) {
      if (
        ((!new_disabled_flg && !formik.values.newentrant_check) ||
          formik.values.newentrant_check) &&
        ((!send_disabled_flg && !formik.values.sendoff_check) || formik.values.sendoff_check) &&
        !(formik.values.newentrant_check && formik.values.sendoff_check)
      ) {
        setInDisabled(false);
      } else {
        setInDisabled(true);
      }
    }
    if (newcomer_education_status === 1 && sendoff_education_status === 2) {
      if (!new_disabled_flg && !formik.values.newentrant_check) {
        setInDisabled(false);
      } else {
        setInDisabled(true);
      }
    }
    if (newcomer_education_status === 2 && sendoff_education_status === 0) {
      if (!send_disabled_flg) {
        setInDisabled(false);
      } else {
        setInDisabled(true);
      }
    }
    if (newcomer_education_status === 2 && sendoff_education_status === 1) {
      if (!send_disabled_flg && !formik.values.sendoff_check) {
        setInDisabled(false);
      } else {
        setInDisabled(true);
      }
    }
  }, [
    newcomer_education_status,
    sendoff_education_status,
    chronic_disease_flg,
    visa_status_kbn,
    formik.values,
    sendoffEducation,
    medical_history_flg,
    scrollFlg,
  ]);

  // 画面を離れる前に初期化
  useEffect(() => {
    const unlisten = history.listen(() => {
      dispatch(actions.setNum({ num: 0 }));
      dispatch(actions.setSendFlg({ send_flg: 0 }));
    });

    return () => {
      unlisten();
    };
  }, [history]);

  return (
    <>
      <NewentrantSendoffStyled>
        <FormikProvider value={formik}>
          <Form layout="vertical" className="form">
            <Spin spinning={loading || initLoading}>
              {/* 新規入場者教育 */}
              <div className="header-group">
                {newOpenFlg && (
                  <Button
                    className="header-left-button"
                    onClick={() => setNewOpenFlg(false)}
                    disabled={!showNewFlg}
                  >
                    —
                  </Button>
                )}
                {!newOpenFlg && (
                  <Button
                    className="header-left-button"
                    onClick={() => setNewOpenFlg(true)}
                    disabled={!showNewFlg}
                  >
                    +
                  </Button>
                )}
                <div className="header-tiltle">◇新規入場者の皆様へ◇</div>
              </div>
              {newcomer_education_status === 1 && (
                <div className="header-group">
                  <CheckboxField
                    name="newentrant_check"
                    onClick={() => {
                      if (formik.values.newentrant_check) {
                        // '0'を登録する ※0：チェックなし、1：チェックあり
                        dispatch(actions.setNewentrantUpdateNotCheckBox({ updateNotCheckBox: 0 }));
                        setDisabledNew(false);
                      } else {
                        // '1'を登録する ※0：チェックなし、1：チェックあり
                        dispatch(actions.setNewentrantUpdateNotCheckBox({ updateNotCheckBox: 1 }));
                        setDisabledNew(true);
                      }
                    }}
                  >
                    実施済の教育があります。上書きする場合は左記のチェックを外してください。
                  </CheckboxField>
                </div>
              )}

              {!showNewFlg && (
                <div className="header-group">
                  <div className="header-tiltle">新規入場者教育は既に承認済です。</div>
                </div>
              )}
              {newOpenFlg && showNewFlg && (
                <>
                  <div className="form-group-tiltle margin-top border-radius-top">
                    （１）作業所の概要
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">工事NO.</div>
                    <div className="form-col-right">{newentrantEducation?.genba_no}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">工事名称</div>
                    <div className="form-col-right">{newentrantEducation?.genba_name}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">工事場所</div>
                    <div className="form-col-right">{newentrantEducation?.genba_address}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">工期</div>
                    <div className="form-col-right">{newentrantEducation?.kouki}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">構造・階数</div>
                    <div className="form-col-right white-space">
                      {newentrantEducation?.structure}
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="form-col">作業時間・周辺交通機関、他</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col white-space">{newentrantEducation?.work_time}</div>
                  </div>
                  <div className="form-group-tiltle" ref={observance_scroll}>
                    （２）作業所の遵守事項
                  </div>
                  <div className="form-group">
                    <div className="form-col">{newentrantEducation?.observance__title}</div>
                  </div>
                  <div className="form-group">
                    <TextAreaField
                      value={newentrantEducation?.observance}
                      name="content"
                      className="textarea"
                      readOnly
                      id="textArea"
                    />
                  </div>
                  <div className="form-group-tiltle margin-top border-radius-top justify-content">
                    ◇新規入場者教育終了報告書◇
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">氏名(カナ)</div>
                    <div className="form-col-right">{newentrantEducation?.worker_name_kana}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">氏名</div>
                    <div className="form-col-right">{newentrantEducation?.worker_name}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">会社名(一次下請)</div>
                    <div className="form-col-right">{newentrantEducation?.first_gyosya_name}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-left align-center">
                      <div className="form-col">緊急連絡先</div>
                    </div>
                    <div className="form-center">
                      <div className="form-col border-bottom">氏名</div>
                      <div className="form-col border-bottom">続柄</div>
                      <div className="form-col">電話番号</div>
                    </div>
                    <div className="form-right">
                      <div className="form-col border-bottom">
                        {newentrantEducation?.emergency.emergency_name}
                      </div>
                      <div className="form-col border-bottom">
                        {newentrantEducation?.emergency.emergency_relationship_name}
                      </div>
                      <div className="form-col">
                        {newentrantEducation?.emergency.emergency_phone_number}
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">現住所</div>
                    <div className="form-col-right">{newentrantEducation?.home_address}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">電話番号</div>
                    <div className="form-col-right">{newentrantEducation?.phone_number}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">生年月日</div>
                    <div className="form-col-right">
                      {dayjs(newentrantEducation?.birth_date).format('YYYY年MM月DD日')}
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">雇主の会社名</div>
                    <div className="form-col-right">{newentrantEducation?.gyosya_name}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">一人親方・事業主</div>
                    <div className="form-col-right">
                      {newentrantEducation?.one_person_chief_name}
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="form-col color-red">
                      ※一人親方・事業主の場合、労災特別加入の加入確認をお願いします。
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="form-col-left">労災保険特別加入制度</div>
                    <div className="form-col-right">
                      {newentrantEducation?.accident_insurance_status}
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">年齢</div>
                    <div className="form-col-right">{newentrantEducation?.age}歳</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">血液型</div>
                    <div className="form-col-right">{newentrantEducation?.blood_type_name}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">血圧</div>
                    <div className="form-col-right">{newentrantEducation?.blood_pressure}</div>
                  </div>
                  <div className="form-group" ref={chronic_disease_flg_scroll}>
                    <div className="form-col-left">健康診断</div>
                    <div className="form-col-right">
                      {dayjs(newentrantEducation?.health_check_date).format('YYYY年MM月DD日')}
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">特殊健康診断</div>
                    <div className="form-col-right">
                      {dayjs(newentrantEducation?.special_health.special_health_check_date).format(
                        'YYYY年MM月DD日'
                      )}
                      ({newentrantEducation?.special_health.special_health_check_name})
                    </div>
                  </div>
                  <div className="form-group" ref={visa_status_kbn_scroll}>
                    <div className="form-col-left">持病</div>
                    <div className="form-col-right">
                      <Radio.Group
                        onChange={onChangeChronicDiseaseFlg}
                        value={chronic_disease_flg}
                        disabled={disabledNew}
                      >
                        <Radio value={1}>有</Radio>
                        <Radio value={0}>無</Radio>
                      </Radio.Group>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="form-col color-red">
                      ※外国人の場合は必須選択 ※日本人は選択不要
                    </div>
                  </div>
                  <div className="form-group" ref={cooperator_scroll}>
                    <div className="form-col-left">在留カード</div>
                    <div className="form-col-right">
                      <Radio.Group
                        onChange={onChangeVisaStatusKbn}
                        value={visa_status_kbn}
                        disabled={disabledNew}
                      >
                        <Radio value={1} disabled={newentrantEducation?.nationality_flg === 0}>
                          確認済
                        </Radio>
                        <Radio value={0} disabled={newentrantEducation?.nationality_flg === 0}>
                          未確認
                        </Radio>
                        {newentrantEducation?.nationality_flg === 0 && (
                          <Radio value={3} disabled={newentrantEducation?.nationality_flg === 0}>
                            対象外
                          </Radio>
                        )}
                      </Radio.Group>
                    </div>
                  </div>
                  <div className="form-group" ref={newentrant_user_name_scroll}>
                    <div className="form-col">新規入場者教育実施者</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">会社名</div>
                    <div className="form-col-right">
                      <SelectField
                        data={upperCooperatorList?.educator_cooperator_list?.map((item) => ({
                          value:
                            item.cooperator_name === '大東建託' ? '大東建託' : item.cooperator_code,
                          label: item.cooperator_name,
                        }))}
                        name="cooperator"
                        className="select-field"
                        disabled={disabledNew}
                        onSelect={(item) => {
                          setCooperator(item);
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">氏名</div>
                    <div className="form-col-right">
                      <InputField
                        name="newentrant_user_name"
                        className="input-field"
                        placeholder="氏名入力欄"
                        disabled={disabledNew}
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="form-col color-red">
                      品質作業手順書を確認し、内容を理解しました。施工基準を遵守し、施工に努めます。
                    </div>
                  </div>
                </>
              )}

              {/* 送り出し教育 */}
              <div className="header-group">
                {sendOpenFlg && (
                  <Button
                    className="header-left-button"
                    onClick={() => setSendOpenFlg(false)}
                    disabled={!showSendFlg}
                  >
                    —
                  </Button>
                )}
                {!sendOpenFlg && (
                  <Button
                    className="header-left-button"
                    onClick={() => setSendOpenFlg(true)}
                    disabled={!showSendFlg}
                  >
                    +
                  </Button>
                )}
                <div className="header-tiltle">◇送り出し教育◇</div>
              </div>
              {sendoff_education_status === 1 && (
                <div className="header-group">
                  <CheckboxField
                    name="sendoff_check"
                    onClick={() => {
                      if (formik.values.sendoff_check) {
                        // '0'を登録する ※0：チェックなし、1：チェックあり
                        dispatch(actions.setSendoffUpdateNotCheckBox({ updateNotCheckBox: 0 }));
                        setDisabledSend(false);
                      } else {
                        // '1'を登録する ※0：チェックなし、1：チェックあり
                        dispatch(actions.setSendoffUpdateNotCheckBox({ updateNotCheckBox: 1 }));
                        setDisabledSend(true);
                      }
                    }}
                  >
                    実施済の教育があります。上書きする場合は左記のチェックを外してください。
                  </CheckboxField>
                </div>
              )}

              {!showSendFlg && (
                <div className="header-group">
                  <div className="header-tiltle">送り出し教育は既に承認済です。</div>
                </div>
              )}
              {sendOpenFlg && showSendFlg && (
                <>
                  <div className="form-group-tiltle margin-top border-radius-top justify-content">
                    ◇送り出し教育終了報告書◇
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">工事NO.</div>
                    <div className="form-col-right">{sendoffEducation?.genba_no}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">工事名称</div>
                    <div className="form-col-right">{sendoffEducation?.genba_name}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">工期</div>
                    <div className="form-col-right">{sendoffEducation?.kouki}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">構造・階数</div>
                    <div className="form-col-right  white-space">{sendoffEducation?.structure}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">工事場所</div>
                    <div className="form-col-right">{sendoffEducation?.genba_address}</div>
                  </div>
                  <div className="form-group" ref={compliance_check_scroll}>
                    <div className="form-col">
                      大東建託(株)作業所の遵守事項(各事項を読み、読んだ項目の□にチェックして下さい)
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="form-col">{sendoffEducation?.compliance_title}</div>
                  </div>
                  {sendoffEducation &&
                    sendoffEducation.compliance_list.map((item, i) => {
                      return (
                        <div className="form-group">
                          <div className="display-flex">
                            <div className="form-col left_check">
                              <CheckboxField
                                name={`${'compliance_check' + i}`}
                                className="compliance_check"
                                disabled={disabledSend}
                              ></CheckboxField>
                            </div>
                            <div className="align-center">　{item.compliance_content}</div>
                          </div>
                        </div>
                      );
                    })}
                  <div className="form-group">
                    <div className="form-col-left">所属会社</div>
                    <div className="form-col-right">{sendoffEducation?.gyosya_name}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">一次会社</div>
                    <div className="form-col-right">{sendoffEducation?.first_gyosya_name}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">フリガナ</div>
                    <div className="form-col-right">{sendoffEducation?.worker_name_kana}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">氏名</div>
                    <div className="form-col-right">{sendoffEducation?.worker_name}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">性別</div>
                    <div className="form-col-right">{sendoffEducation?.sex_name}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">生年月日</div>
                    <div className="form-col-right">
                      {dayjs(sendoffEducation?.birth_date).format('YYYY年MM月DD日')}
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">年齢</div>
                    <div className="form-col-right">{sendoffEducation?.age}歳</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">血液型</div>
                    <div className="form-col-right">{sendoffEducation?.blood_type_name}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">業種</div>
                    <div className="form-col-right">{sendoffEducation?.job_category_name}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">経験年数</div>
                    <div className="form-col-right">{sendoffEducation?.experience_years}年</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">現住所</div>
                    <div className="form-col-right">{sendoffEducation?.home_address}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">電話番号</div>
                    <div className="form-col-right">{sendoffEducation?.phone_number}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-left align-center">
                      <div className="form-col">緊急連絡先</div>
                    </div>
                    <div className="form-center">
                      <div className="form-col border-bottom">住所</div>
                      <div className="form-col border-bottom">電話番号</div>
                      <div className="form-col border-bottom">氏名</div>
                      <div className="form-col border-bottom">続柄</div>
                      <div className="form-col">e-mail</div>
                    </div>
                    <div className="form-right">
                      <div className="form-col border-bottom">
                        {sendoffEducation?.emergency.emergency_address}
                      </div>
                      <div className="form-col border-bottom">
                        {sendoffEducation?.emergency.emergency_phone_number}
                      </div>
                      <div className="form-col border-bottom">
                        {sendoffEducation?.emergency.emergency_name}
                      </div>
                      <div className="form-col border-bottom">
                        {sendoffEducation?.emergency.emergency_relationship_name}
                      </div>
                      <div className="form-col">{sendoffEducation?.emergency.mail_address}</div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">雇用形態</div>
                    <div className="form-col-right">{sendoffEducation?.employment_name}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">保険</div>
                    <div className="form-col-right">
                      {sendoffEducation?.employment_insurance_name}
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">健康診断</div>
                    <div className="form-col-right">
                      {dayjs(sendoffEducation?.health_check_date).format('YYYY年MM月DD日')}
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">血圧</div>
                    <div className="form-col-right">{sendoffEducation?.blood_pressure}</div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left">特殊健康診断</div>
                    <div className="form-col-right">
                      {dayjs(sendoffEducation?.special_health.special_health_check_date).format(
                        'YYYY年MM月DD日'
                      )}
                      ({sendoffEducation?.special_health.special_health_check_name})
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left align-center">既往歴</div>
                    <div className="form-right">
                      <div className="form-col border-bottom" ref={medical_history_flg_scroll}>
                        あなたは既往歴又は現在治療中の病気が有りますか？
                      </div>
                      <div className="form-col border-bottom" ref={medical_history_list_scroll}>
                        <Radio.Group
                          name="medical_history_flg"
                          onChange={onChangeMedicalHistoryFlg}
                          value={medical_history_flg}
                          disabled={disabledSend}
                        >
                          <Radio value={'0'}>ない</Radio>
                          <Radio value={'1'}>ある</Radio>
                        </Radio.Group>
                      </div>

                      {sendoffEducation?.medical_history_list?.map((item, i) => {
                        if (i % 2 === 0) {
                          return (
                            <div className="display-flex border-bottom">
                              {/* 左側(index==i) 既往歴チェック  */}
                              <>
                                <div className="form-col left_check">
                                  <CheckboxField
                                    name={`${'medical_history_code' + item.medical_history_code}`}
                                    disabled={disabledHistory}
                                    onClick={() => {
                                      if (item.medical_history_code === 99) {
                                        //「既往歴チェック」の「その他」にチェックが有る場合
                                        // 活性・非活性：以下の項目は、非活性から活性を変更する。
                                        // 既往歴その他
                                        const else_check = document.getElementsByName(
                                          'medical_history_code' + item.medical_history_code
                                        )[0] as HTMLInputElement;
                                        if (!else_check.checked) {
                                          setDisabledElse(true);
                                        } else {
                                          setDisabledElse(false);
                                        }
                                      }
                                    }}
                                  ></CheckboxField>
                                </div>
                                <div className="align-center left_check_history">
                                  　{item.medical_history_content}
                                </div>
                              </>
                              {/* 右側(index==i+1) 既往歴チェック */}
                              {i + 1 <= sendoffEducation?.medical_history_list?.length - 1 && (
                                <>
                                  <div className="form-col left_check">
                                    <CheckboxField
                                      name={`${
                                        'medical_history_code' +
                                        sendoffEducation?.medical_history_list[i + 1]
                                          ?.medical_history_code
                                      }`}
                                      disabled={disabledHistory}
                                      onClick={() => {
                                        if (
                                          sendoffEducation?.medical_history_list[i + 1]
                                            ?.medical_history_code === 99
                                        ) {
                                          //「既往歴チェック」の「その他」にチェックが有る場合
                                          // 活性・非活性：以下の項目は、非活性から活性を変更する。
                                          // 既往歴その他
                                          const else_check = document.getElementsByName(
                                            'medical_history_code' +
                                              sendoffEducation?.medical_history_list[i + 1]
                                                ?.medical_history_code
                                          )[0] as HTMLInputElement;
                                          if (!else_check.checked) {
                                            setDisabledElse(true);
                                          } else {
                                            setDisabledElse(false);
                                          }
                                        }
                                      }}
                                    ></CheckboxField>
                                  </div>
                                  <div className="align-center">
                                    　
                                    {
                                      sendoffEducation?.medical_history_list[i + 1]
                                        ?.medical_history_content
                                    }
                                  </div>
                                </>
                              )}
                              {/* 既往歴リストが奇数の場合 その他入力欄 */}
                              {sendoffEducation?.medical_history_list?.length % 2 !== 0 &&
                                i === sendoffEducation?.medical_history_list?.length - 1 && (
                                  <div
                                    className="form-col left_check_else"
                                    ref={medical_history_else_scroll}
                                  >
                                    <InputField
                                      name="medical_history_else"
                                      className="input-field"
                                      placeholder="その他入力欄"
                                      disabled={disabledElse}
                                    />
                                  </div>
                                )}
                            </div>
                          );
                        }
                      })}

                      {/* 既往歴リストが偶数の場合 その他入力欄 */}
                      {sendoffEducation?.medical_history_list?.length % 2 === 0 && (
                        <div className="form-col border-bottom" ref={medical_history_else_scroll}>
                          <InputField
                            name="medical_history_else"
                            className="input-field"
                            placeholder="その他入力欄"
                            disabled={disabledElse}
                          />
                        </div>
                      )}
                      <div className="form-col border-bottom" ref={work_limit_flg_scroll}>
                        あなたに既往歴がある場合、制限なく作業ができますか？
                      </div>
                      <div className="form-col border-bottom">
                        <Radio.Group
                          onChange={onChangeWorkLimitFlg}
                          value={work_limit_flg}
                          disabled={disabledHistory}
                        >
                          <Radio value={'0'}>できる</Radio>
                          <Radio value={'1'}>できない</Radio>
                        </Radio.Group>
                      </div>
                      <div className="form-col border-bottom" ref={work_limit_reason_scroll}>
                        <InputField
                          name="work_limit_reason"
                          className="input-field"
                          placeholder="作業制限入力欄"
                          disabled={disabledLimit}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left align-center" ref={emergency_report_check_scroll}>
                      緊急時報告
                    </div>
                    <div className="form-right">
                      <div className="form-col border-bottom">
                        ・大東建託(株)工事担当者に速やかに報告する事。(事故・クレーム・災害等)
                      </div>
                      <div className="display-flex">
                        <div className="form-col left_check">
                          <CheckboxField
                            name="emergency_report_check"
                            disabled={disabledSend}
                          ></CheckboxField>
                        </div>
                        <div className="align-center">　はい</div>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="form-col">
                      送り出し教育実施者(一次下請けの事業主または雇用主)
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="form-col-left" ref={sendoff_user_name_scroll}>
                      氏名
                    </div>
                    <div className="form-col-right">
                      <InputField
                        name="sendoff_user_name"
                        className="input-field"
                        placeholder="氏名入力欄"
                        disabled={disabledSend}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="form-group-bottom margin-top border-radius-top justify-content">
                <ButtonSubmit disabled={inDisabled}>確定</ButtonSubmit>
              </div>
            </Spin>
          </Form>
        </FormikProvider>
      </NewentrantSendoffStyled>
      {/* 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ start */}
      {isKakunin && (
        <Kakunin
          new_education_user_name={formik.values.newentrant_user_name}
          education_user_name={formik.values.sendoff_user_name}
          user_name={worker_data?.worker_name}
          visible={isKakunin}
          onCancel={onCancel}
          onOk={onOk}
        />
      )}
      {/* 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ end */}
    </>
  );
};

export default NewentrantSendoff;

const initialValues = {
  newentrant_check: false,
  cooperator: '',
  newentrant_user_name: '',
  sendoff_check: false,
  medical_history_else: '',
  work_limit_reason: '',
  emergency_report_check: false,
  sendoff_user_name: '',
};
// 2023/01/11 Leading Win 教育機能対応 DXWEBEFN00100_新規入場・送り出し教育 end
